const apiKey = process.env.NEXT_PUBLIC_GOOGLE_API;
let googleMapsScriptLoadingPromise = null;

export function loadGoogleMapsScript() {
  // Avoid SSR execution
  if (typeof window === "undefined") return Promise.resolve();

  // Already available
  if (window.google?.maps?.places) {
    return Promise.resolve(window.google);
  }

  // If already loading, return the same promise
  if (googleMapsScriptLoadingPromise) {
    return googleMapsScriptLoadingPromise;
  }

  // Create and cache the loading promise
  googleMapsScriptLoadingPromise = new Promise((resolve, reject) => {
    // Check for existing script tag
    if (document.getElementById("google-maps")) {
      // Wait briefly to ensure it's loaded
      const interval = setInterval(() => {
        if (window.google?.maps?.places) {
          clearInterval(interval);
          resolve(window.google);
        }
      }, 50);
      return;
    }

    const script = document.createElement("script");
    script.id = "google-maps";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve(window.google);
    script.onerror = reject;

    document.head.appendChild(script);
  });

  return googleMapsScriptLoadingPromise;
}
